import React from 'react';
import Navbar from '@/components/salon/Navbar';
import { Card } from '@/components/ui/card';
import { FileText } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <FileText className="w-8 h-8 text-blue-600" />
            <h1 className="text-4xl font-bold text-slate-900">Impressum</h1>
          </div>
        </div>

        <Card className="p-8">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="text-slate-700 space-y-2">
              <p><strong>Salon Galo</strong></p>
              <p>Inhaber: Joe Galo</p>
              <p>Heilermannstrasse 6</p>
              <p>45138 Essen</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Kontakt</h2>
            <div className="text-slate-700 space-y-2">
              <p>Telefon: +49 163 684 9710</p>
              <p>E-Mail: salongalo@gmx.de</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="text-slate-700 space-y-2">
              <p>Joe Galo</p>
              <p>Heilermannstr. 6</p>
              <p>45138 Essen</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Streitschlichtung</h2>
            <p className="text-slate-700 mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            </p>
            <a 
              href="https://ec.europa.eu/consumers/odr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            <p className="text-slate-700 mt-4">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="bg-slate-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Haftungsausschluss</h2>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Haftung für Inhalte</h3>
            <p className="text-slate-700 text-sm mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
            </p>
            
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Haftung für Links</h3>
            <p className="text-slate-700 text-sm">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>
        </Card>
      </div>
    </div>
  );
};

export default ImpressumPage;
